//===================================
// Gallery full
//===================================

import { SplideGallery } from "../includes/splide";

SplideGallery('.gallery-carousel .splide', {
  perMove: 1,
  type: 'loop',
  autoplay: true,
  interval: 5000,
  arrows: true,
  pagination: false,
  fixedWidth: '35rem',
  gap: '2.25rem',
  breakpoints: {
    639: {
      perPage: 1,
      fixedWidth: false
    }
  }
});